// @flow

import React, { type Node } from 'react';
import { type Country } from '@tectonics/prs/country';
import { Content, Footer, Main, Title, Wrapper } from '../layout';
import { EbanxLogo } from '../ebanx-logo';

type Props = {|
  +country: Country,
|};

export function CanceledPaymentPage({ country }: Props): Node {
  return (
    <Wrapper>
      <Main>
        <Content centered>
          <Title>
            <TitleMessage country={country} />
          </Title>
        </Content>
      </Main>
      <Footer>
        <FooterContent country={country} />
      </Footer>
    </Wrapper>
  );
}

type TitleMessageProps = {|
  +country: Country,
|};

function TitleMessage({ country }: TitleMessageProps): Node {
  switch (country) {
    case 'br':
      return 'Esse pagamento foi cancelado';

    default:
      return 'Este pago fue cancelado';
  }
}

type FooterContentProps = {|
  +country: Country,
|};

function FooterContent({ country }: FooterContentProps): Node {
  switch (country) {
    case 'br':
      return <>Pagamento seguro via <EbanxLogo /></>;

    default:
      return <>Pagamento seguro vía <EbanxLogo /></>;
  }
}
